<template>
    <div class="detail">
        <Carousel :list="config.banner.detail"/>
        <Sections>
            <div class="main" v-if="config && config.news[id]" v-html="config.product[id].html">
                
            </div>
        </Sections>
    </div>
</template>
<script>
    import Carousel from '@/components/Carousel'
    import Sections from '@/components/Sections'
    export default {
        components: {
            Carousel,Sections
        },
        created(){
            this.id = this.$route.params.id;
        },
        data(){
            return{
                config,
                id:null
            }
        },
        watch:{
            $route(n,o){
                this.id = this.$route.params.id;
            }
        }
    }
</script>
<style lang="less">
    .detail{
        .main{
            max-width: 1200px;
            margin: 0 auto;
            overflow-x: auto;
            img{
                display: block;
                margin:  0 auto;
                max-width: 100% !important;
                margin-bottom: 10px;
                height: auto;
            }
        }
    }
</style>
